const _emptyState = Object.freeze(new Array());
export const LegendStatePlugin = {
    id: 'legendState',
    afterUpdate(chart, _, options) {
        if (!options.display) {
            options.onChartChange?.(_emptyState);
            return;
        }
        // Reuse the built-in legendItems generator
        const items = chart.options.plugins?.legend?.labels?.generateLabels?.(chart) ?? [];
        const pluginItems = items.map((item) => ({
            ...item,
            onClick: () => {
                const type = 'type' in chart.config && chart.config.type;
                if ((type === 'pie' || type === 'doughnut') && item.index !== undefined) {
                    // Pie and doughnut charts only have a single dataset and visibility is per item
                    chart.toggleDataVisibility(item.index);
                }
                else if (item.datasetIndex !== undefined) {
                    chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                }
                chart.update();
            },
        }));
        options.onChartChange(pluginItems);
    },
};
